import { doc, collection, query, getDoc, getDocs, where } from 'firebase/firestore';
import { db } from './../firebase';
import moment from 'moment';
import * as XLSX from 'xlsx';

export const ExportMonthXLS = async (onProgress) => {
  let data = [];
  if (onProgress) onProgress(0);

  // Fecha del mes a exportar
  const targetDate = moment().subtract(1, 'month');

  const users = await getDocs(query(collection(db, 'users'), where('estadoSesion', '!=', 'Deshabilitado')));
  const totalUsers = users.docs.length;
  let processedUsers = 0;
  for (const user of users.docs) {
    if (user.data().calendario?.[targetDate.format('YYYY')]) {
      //Obtengo el calendario del usuario
      const calendario = await getDoc(doc(db, 'calendars', user.data().calendario[targetDate.format('YYYY')].id));

      //Obtengo el total de horas teóricas del mes anterior
      const teorico = calendario.data().data[targetDate.format('MMMM')]?.total || 0;

      //Obtengo las horas del mes anterior separando ordinarias y festivos
      let horasTrabajadas = 0;
      let festivosAprobados = 0;
      let festivosNoAprobados = 0;

      const registrosDoc = await getDoc(doc(db, 'users', user.id, 'registros', targetDate.format('MMMM-YYYY')));

      if (registrosDoc.exists()) {
        Object.values(registrosDoc.data()).forEach((item) => {
          var long = Object.keys(item).length;
          let totalDay = 0;
          while (totalDay <= 0 && long > 0) {
            if (item[long - 1].totalAcumulado) {
              totalDay = item[long - 1].totalAcumulado.split(':')[0] * 60 + parseInt(item[long - 1].totalAcumulado.split(':')[1]);
            }
            long--;
          }

          if (item[0]?.tpRegistro === 'Festivo') {
            if (item[0]?.status === 'Aceptado') {
              festivosAprobados += totalDay;
            } else {
              festivosNoAprobados += totalDay;
            }
          } else {
            // Horas trabajadas ordinarias: no cuentan las de tipo festivo
            if (item[0]?.status !== 'Pendiente') {
              horasTrabajadas += totalDay;
            }
          }
        });
      }

      //Obtengo las ausencias del mes anterior
      let totalAusencias = 0;
      const absences = await getDocs(query(collection(db, 'users', user.id, 'ausencias'), where('status', '==', 'Aceptado'))).then((doc) => {
        let absences = {};
        doc.forEach((document) => {
          //si hay registros de vacaciones en este mes
          //prettier-ignore
          if (moment(document.data().startDate, 'DD/MM/YYYY').format('MM/YYYY') === targetDate.format('MM/YYYY') || moment(document.data().endDate, 'DD/MM/YYYY').format('MM/YYYY') === targetDate.format('MM/YYYY')) {
            //SE PUEDE SACAR A UNA FUNCIÓN(MONTHLYBALANCE, MONTHLYREMAINING ..)
            let start = moment(document.data().startDate, 'DD/MM/YYYY');
            let end = moment(document.data().endDate, 'DD/MM/YYYY');

            //Detectar si hay cambio de mes en el periodo de vacaciones
            if (start.format('MM') !== end.format('MM')) {
              if (start.format('MM') === targetDate.format('MM')) {
                end = targetDate.clone().endOf('month');
              } else {
                start = targetDate.clone().startOf('month');
              }
            }

            for (var m = start.clone(); m.isBefore(end.clone().add(1, 'days')); m.add(1, 'days')) {
              let horas = calendario.data().data[targetDate.format('MMMM')].days.find((day) => day.date === m.format('YYYY-MM-DD')).hours;
              horas = horas.split(':')[0] * 60 + parseInt(horas.split(':')[1]);
              absences[document.data().type] = absences[document.data().type] ? absences[document.data().type] + horas : horas;
              totalAusencias += horas;
            }

            //absences[document.data().type] = absences[document.data().type] ? absences[document.data().type] + document.data().total : document.data().total;
          }
        });
        return absences;
      });

      // El total computa las horas trabajadas ordinarias, los festivos aprobados y las ausencias justificadas
      const totalGlobal = horasTrabajadas + festivosAprobados + totalAusencias;

      data.push([
        user.data().displayName,
        user.data().departamento,
        teorico && typeof teorico === 'string' && teorico.includes(':') ? new Date(0, 0, 0, teorico.split(':')[0], teorico.split(':')[1]) : new Date(0, 0, 0, 0, 0),
        new Date(0, 0, 0, Math.floor(horasTrabajadas / 60), horasTrabajadas % 60),
        absences['Vacaciones'] ? new Date(0, 0, 0, Math.floor(absences['Vacaciones'] / 60), absences['Vacaciones'] % 60) : new Date(0, 0, 0, 0, 0),
        absences['Asuntos_propios'] ? new Date(0, 0, 0, Math.floor(absences['Asuntos_propios'] / 60), absences['Asuntos_propios'] % 60) : new Date(0, 0, 0, 0, 0),
        absences['Enfermedad'] ? new Date(0, 0, 0, Math.floor(absences['Enfermedad'] / 60), absences['Enfermedad'] % 60) : new Date(0, 0, 0, 0, 0),
        new Date(0, 0, 0, Math.floor(festivosAprobados / 60), festivosAprobados % 60),
        new Date(0, 0, 0, Math.floor(festivosNoAprobados / 60), festivosNoAprobados % 60),
        new Date(0, 0, 0, Math.floor(totalGlobal / 60), totalGlobal % 60),
      ]);
    } else {
      alert(
        'El usuario ' +
          user.data().displayName +
          ' no tiene calendario asignado para el año ' +
          targetDate.format('YYYY') +
          ' y no se ha tenido en cuenta en la generación del informe.'
      );
    }
    processedUsers++;
    if (onProgress) onProgress(Math.round((processedUsers / totalUsers) * 90));
  }

  //Ordenar por departamento
  data.sort((a, b) => {
    if (a[1] < b[1]) return -1;
    if (a[1] > b[1]) return 1;
    return 0;
  });

  // Crear un nuevo libro de trabajo
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([
    ['Empleado', 'Departamento', 'Horas Teóricas', 'Horas Trabajadas', 'Vacaciones', 'Asuntos Propios', 'Enfermedad', 'Festivos Aprobados', 'Festivos No Aprobados', 'Total'],
    ...data.map((item) => [item[0], item[1], item[2], item[3], item[4], item[5], item[6], item[7], item[8], item[9]]),
  ]);

  // Establecer el formato de celda para la columna de tiempo
  const colWidth = [{ wch: 20 }];
  ws['!cols'] = colWidth;

  // Establecer el formato de celda para la columna de tiempo
  const timeFormat = '[h]:mm;@';

  // Establecer el formato de celda para las columnas 2 a 9
  for (let r = 1; r <= data.length; r++) {
    for (let c = 2; c <= 9; c++) {
      const cell = XLSX.utils.encode_cell({ r, c });
      if (ws[cell] && ws[cell].t === 'n') {
        ws[cell].z = timeFormat;
      }
    }
  }

  // Agregar la hoja al libro
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  // Guardar el libro como un archivo Excel
  XLSX.writeFile(wb, 'Mensual.xlsx');
  if (onProgress) onProgress(100);
  console.log('Archivo de Excel creado exitosamente.');
};
